module.exports = __webpack_public_path__ + "static/media/forDoctorss5.8463b89e.png";